
(function ($, d, ns) {

    $(d).ready(function () {
        if (typeof CloudZoom !== "undefined") {
            CloudZoom.quickStart();
        }
    });

})(jQuery, document, Crafted.Utilities);